import React, { useState, useEffect } from 'react';
import { decryptData, defaulUrl } from '../components/const';
import Swal from 'sweetalert2';

function ModalEditPubMedia({ isOpen, onClose, media }) {
    const [titre, setTitre] = useState(media?.titre || '');
    const [description, setDescription] = useState(media?.description || '');
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [type, setType] = useState(media?.image ? 'image' : 'video');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (media) {
            setTitre(media.titre || '');
            setDescription(media.description || '');
            setType(media.image ? 'image' : 'video');
            setPreviewUrl(
                media.image
                    ? `${defaulUrl}upload/Publicite/${media.image}`
                    : `${defaulUrl}upload/Publicite/${media.video}`
            );
        }
    }, [media]);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;
        const fileType = selectedFile.type;
        setType(fileType.startsWith('video/') ? 'video' : 'image');
        setFile(selectedFile);
        setPreviewUrl(URL.createObjectURL(selectedFile));
    };

    const handleSubmit = async () => {
        if (!titre || !description) return alert('Veuillez remplir tous les champs');

        const formData = new FormData();
        formData.append('titre', titre);
        formData.append('description', description);
        formData.append('type', type);

        // Ajouter le fichier uniquement si modifié
        if (file) {
            formData.append('media', file);
        }

        setIsLoading(true);
        try {
            const response = await fetch(`${defaulUrl}admin-site/update-${media.image ? 'image' : 'video'}/${media.id}`, {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + decryptData('ACCESS_TOKEN'),
                    Accept: 'application/json',
                },
                body: formData,
            });

            const data = await response.json();
            setIsLoading(false);

            if ([200, 201].includes(response.status)) {
                Swal.fire('Succès', 'Modification effectuée', 'success');
                handleClose();

            } else {
                Swal.fire('Erreur', data.message || 'Erreur de mise à jour', 'error');
            }
        } catch (err) {
            console.error(err);
            setIsLoading(false);
            Swal.fire('Erreur', 'Une erreur est survenue', 'error');
        }
    };

    const handleClose = () => {
        setTitre('');
        setDescription('');
        setFile(null);
        setPreviewUrl(null);
        onClose();
    };

    if (!isOpen || !media) return null;

    return (
        <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            {isLoading && <div className="loader"></div>}
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Modifier le média publicitaire</h5>
                        <button type="button" className="btn-close" onClick={handleClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group mb-2">
                            <label>Titre</label>
                            <input
                                type="text"
                                className="form-control"
                                value={titre}
                                onChange={(e) => setTitre(e.target.value)}
                            />
                        </div>

                        <div className="form-group mb-2">
                            <label>Description</label>
                            <textarea
                                className="form-control"
                                rows="3"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            ></textarea>
                        </div>

                        {/* {previewUrl && type === 'image' && (
                            <img src={previewUrl} alt="aperçu" className="img-fluid rounded" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                        )}

                        {previewUrl && type === 'video' && (
                            <video src={previewUrl} controls className="w-100 rounded" style={{ maxHeight: '300px' }} />
                        )} */}

                        <div className="form-group mb-3" hidden>
                            <label>Changer le fichier (facultatif)</label>
                            <input
                                type="file"
                                accept="image/*,video/*"
                                className="form-control"
                                onChange={handleFileChange}
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>Annuler</button>
                        <button type="button" className="btn btn-primary" onClick={handleSubmit}>Enregistrer</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalEditPubMedia;
